import { fromJS } from 'immutable';

import {
  REQUEST_MONITOR_OVERALL_STATS,
  REQUEST_MONITOR_OVERALL_STATS_SUCCESS,
  REQUEST_MONITOR_OVERALL_STATS_FAILURE,
} from './types';

const initialState = fromJS({
  data: false,
  network: {
    loading: false,
    error: false,
  },
});

export function monitorOverallStatsRequest(entityId) {
  return {
    type: REQUEST_MONITOR_OVERALL_STATS,
    entityId,
  };
}

export function monitorOverallStatsSuccess(response) {
  return {
    type: REQUEST_MONITOR_OVERALL_STATS_SUCCESS,
    response,
  };
}

export function monitorOverallStatsFailure(error) {
  return {
    type: REQUEST_MONITOR_OVERALL_STATS_FAILURE,
    error,
  };
}

export default function monitorOverallStatsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_MONITOR_OVERALL_STATS:
      return state.setIn(['network', 'loading'], true);

    case REQUEST_MONITOR_OVERALL_STATS_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .set('data', fromJS(action.response)),
      );

    case REQUEST_MONITOR_OVERALL_STATS_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], action.error)
          .set('data', false),
      );

    default:
      return state;
  }
}
